import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {Slot} from 'src/shared/models/macro-slot.interface';
import {LoadingPointStartEndHour} from "../../models/planning.interface";

@Injectable()
export class MacroSlotService {
  url: string = `${environment.backend_url}/api/v1/macro-slot`;

  constructor(private readonly http: HttpClient) {}

  getMacroSlotsByDay(runDate: string): Observable<Slot[]> {
    return this.http.get<Slot[]>(`${this.url}`, {
      params: { runDate: runDate },
    });
  }

  getMacroSlots(): Observable<Slot[]> {
    return this.http.get<Slot[]>(`${this.url}`);
  }

  getPlanningOpeningAndClosingHours(
    runDate: string,
  ): Observable<LoadingPointStartEndHour> {
    return this.http.get<LoadingPointStartEndHour>(
      `${this.url}/opening-closing-hour`,
      { params: { runDate: runDate } },
    );
  }
}
